module.exports = __webpack_public_path__ + "img/FinTecrity-logo.a017a4de.svg";